import React, { useState } from 'react'
import s from './OrderTeaser.module.css'
import Image from "next/legacy/image"
import { Button } from '@components/ui'
import Link from 'next/link'


export interface IListForm {
  text: string
  icon: string
}

export interface OrderTeaserProps {
  title?: string
  subtitle?: string
  variantId?: string
  buttonText?: string
  image?: any
  className?: string
  text?: any
  list?: Array<IListForm>
}

const OrderTeaser: React.FC<OrderTeaserProps> = ((props) => {
  let {
    list,
    text,
    className,
    variantId,
    buttonText,
    title,
    subtitle,
    image,
  } = props

  return (
    <div className={`${s.root}`}>
      <div>
        <div className={`grid grid-cols-1 lg:grid-cols-2`}>
          <div className='md:mr-0 md:ml-space10 xl:mr-space10'>
            <div className={'col-start-2 md:col-start-1 h-full w-full relative'}>
              <div className={s.innerWrapper}>
                <div>
                  <h3 className={`${s.title} w-e336 md:w-e446 lg:w-e600`}>{title}<span className={'block'}>{subtitle}</span></h3>
                </div>
                <div>
                  {text &&
                    <div className={'lg:px-10 w-e336 md:w-e446 lg:w-e575'}>
                      <p>{text}</p>
                    </div>
                  }
                  {list &&
                    <div>
                      <ul className={s.list}>
                        {list && list.map((item, index) => {
                          return <li className={s.item + ' relative'} key={index}>
                            <h4 className={`text-neutral900 lh-24 mb-space2 relative`}>
                              <span className={item.icon + ' text-icon22 text-middle md:lh-24 absolute left-0 top-0'}></span>
                              <span className={'text-paragraph02 md:text-paragraph01 align-top ml-space4 pl-space6 block'}>{item.text}</span>
                            </h4>
                          </li>
                        })}
                      </ul>
                    </div>
                  }
                </div>
                <div className={'lg:px-10 text-center md:text-left'}>
                  <Link target={variantId && parseInt(variantId) > 0 ? '_self' : '_blank'} href={variantId && parseInt(variantId) > 0 ? '/quick-buy?variantId='+variantId+'&quantity=1' : variantId as string} legacyBehavior passHref>
                  <Button className={'mt-space6 md:mt-space16'}
                          variant='outlineMedium'
                          >{buttonText}</Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className={s.titleCover + ' row-start-1'}>
            {image && <div
              className={s.image + ' block w-full h-full block overflow-hidden relative'} >
              <Image alt='Order teaser image' priority={false} loading="lazy" src={image} layout='fill' objectFit='cover' />
            </div>}
          </div>
        </div>
      </div>
    </div>
  )
})

export default OrderTeaser
